import { render } from "./AppMonitor.vue?vue&type=template&id=22bfa3c6&scoped=true"
import script from "./AppMonitor.vue?vue&type=script&lang=js"
export * from "./AppMonitor.vue?vue&type=script&lang=js"

import "./AppMonitor.vue?vue&type=style&index=0&id=22bfa3c6&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bfa3c6"]])

export default __exports__